import { render, staticRenderFns } from "./AdminProductRequest.vue?vue&type=template&id=53a35442&scoped=true&"
import script from "./AdminProductRequest.vue?vue&type=script&lang=js&"
export * from "./AdminProductRequest.vue?vue&type=script&lang=js&"
import style0 from "./AdminProductRequest.vue?vue&type=style&index=0&id=53a35442&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a35442",
  null
  
)

export default component.exports